import FlightsService from "../../services/flights.service";

const state = {
    flights: [],
    flight: [],
    JsonFuelDetails : [],
    JRjson: null,
    BlockFuelEstimatedWeightKg : -9999,
    BlockFuelDurationMin : -9999,
    selectedFlightRow: '',
    detailMessage: {
        FKey1: '',
        text: 'Please click a flight...',
        color: '#03a9f47d'
    },
};

const mutations = {
    set_clear_flight(state) {
        state.flight = []
    },

    set_clear_flights(state){
        state.flights = []
    },

    set_flight_list(state, payload) {
        state.flights = payload;
    },

    set_fuelDetails(state,payload)
    {
        state.JsonFuelDetails =payload[0];
    },

    set_JRjson_data(state,payload)
    {
        if(payload != null)
        {
            state.JRjson = payload;
            state.BlockFuelEstimatedWeightKg = payload.poFuel.BlockFuelEstimatedWeightKg    ;
            state.BlockFuelDurationMin = payload.poFuel.BlockFuelDurationMin                ;
        }
    },

    set_flight(state, payload) {
        state.flight = payload;
    },

    set_selected_flight(state, payload) {
        state.selectedFlightRow = payload;
    },

    set_detail_message(state, payload) {
        state.detailMessage = payload;
    }

};

const actions = {

    // archive stat
    async GetJRjsonData({commit},{KFZ,STD,JLVT,archiveStat})
    {
        const JRjsonData = await FlightsService.GetJrJson(KFZ,STD,JLVT,archiveStat);
        commit( "set_JRjson_data" , JRjsonData);
        return JRjsonData;
    },

    async getFlights({commit}, payload)
    {
        await commit("set_clear_flights")
        const flights = await FlightsService.GetFlightsService(payload);

        await commit("set_flight_list", flights);
        return flights;
    },

    async getFlight({commit}, payload) {
        await commit("set_clear_flight")
        await commit("set_flight", payload);
        return payload;
    },

    async getAdvancedSearch({commit}, payload) {
        const flights = await FlightsService.GetAdvanceSearch(payload);
        await commit("set_flight_list", flights);
        return flights
    }

};
export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
